module.exports = __webpack_public_path__ + "static/media/hdc-51-connect.1a17b5f2.png";